import { useMutation } from "@tanstack/react-query";
import { login } from "../../service/query/auth";
import { toast } from "react-toastify";
import useToken from "../usetoken";
import useLocalStorage from "../useLocalStorage";
import { useNavigate } from "react-router-dom";

export const useLogin = () => {
  const { setToken } = useToken();
  const { setLocalStorage } = useLocalStorage();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      const userData = data?.data?.data;
      setToken(userData.token);
      setLocalStorage("user", { ...userData.user });
      setLocalStorage("priviledges",  userData?.menu_privilleges);
      toast.success("Login successful");
      navigate("/dashboard");

      return;
    },
    onError: (error) => {
      console.error("Login error:", error);
      toast(error?.response?.data?.message || "An error occurred");
      return;
    },
  });
};
